import { render, staticRenderFns } from "./ExternalImportErrors.vue?vue&type=template&id=48f920bd&scoped=true"
import script from "./ExternalImportErrors.vue?vue&type=script&lang=js"
export * from "./ExternalImportErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f920bd",
  null
  
)

export default component.exports